import styled, { css } from "styled-components";

// Paleta Sysdent: #0c8de3, #67D2DC, #0C234C
export const WizardContainer = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f0f4f8 0%, #e6effa 100%);
  padding: 2.5rem 1rem;
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const WizardLeftCol = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

export const WizardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;

  .logo {
    height: 48px;
    object-fit: contain;
    margin-bottom: 1rem;
  }
`;

export const ProgressWrapper = styled.div`
  width: 100%;
  margin-bottom: 2rem;
`;

export const ProgressBarTrack = styled.div`
  height: 6px;
  background: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
  position: relative;
`;

export const ProgressBarFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #0c8de3 0%, #67D2DC 100%);
  width: ${(props) => props.percent}%;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 999px;
`;

export const StepIndicatorRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
`;

export const StepCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 2rem 2.5rem;
  box-shadow: 0 4px 20px rgba(12, 35, 76, 0.05);
  border: 1px solid #eef2f6;

  @media (max-width: 768px) {
    padding: 1.5rem 1.25rem;
  }
`;

export const StepTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: #0C234C;
  margin-bottom: 0.35rem;
  text-align: center;
`;

export const StepSubtitle = styled.p`
  font-size: 0.9rem;
  color: #64748b;
  text-align: center;
  margin-bottom: 1.75rem;
`;

export const FormGroup = styled.div`
  margin-bottom: 1.25rem;

  label {
    display: block;
    font-size: 0.85rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.35rem;
  }

  .optional-tag {
    font-size: 0.75rem;
    font-weight: 400;
    color: #94a3b8;
    margin-left: 0.35rem;
  }
`;

export const InputField = styled.input`
  width: 100%;
  height: 46px;
  padding: 0 1rem;
  border-radius: 10px;
  border: 1.5px solid #cbd5e1;
  font-size: 0.95rem;
  color: #1e293b;
  background: #ffffff;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #0c8de3;
    box-shadow: 0 0 0 3px rgba(12, 141, 227, 0.15);
  }

  &::placeholder {
    color: #94a3b8;
  }
`;

export const PhoneInputGroup = styled.div`
  display: flex;
  gap: 0.5rem;

  .country-code {
    width: 90px;
    height: 46px;
    border-radius: 10px;
    border: 1.5px solid #cbd5e1;
    background: #f8fafc;
    font-size: 0.9rem;
    font-weight: 600;
    color: #334155;
    padding: 0 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
  }

  input {
    flex: 1;
  }
`;

export const GoogleAuthBtn = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 10px;
  border: 1.5px solid #cbd5e1;
  background: #ffffff;
  color: #1e293b;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 1.25rem;

  &:hover {
    background: #f8fafc;
    border-color: #94a3b8;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  img {
    width: 20px;
    height: 20px;
  }
`;

export const DividerText = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin: 1.25rem 0;
  color: #94a3b8;
  font-size: 0.8rem;
  font-weight: 500;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #e2e8f0;
  }

  span {
    padding: 0 0.75rem;
  }
`;

export const SelectableCardsGrid = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.columns ? `repeat(${props.columns}, 1fr)` : 'repeat(2, 1fr)')};
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const SelectableCard = styled.div`
  border-radius: 12px;
  padding: 1.25rem 1rem;
  border: 2px solid ${(props) => (props.selected ? '#0c8de3' : '#e2e8f0')};
  background: ${(props) => (props.selected ? '#f0f8ff' : '#ffffff')};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: ${(props) => (props.horizontal ? 'row' : 'column')};
  align-items: center;
  text-align: ${(props) => (props.horizontal ? 'left' : 'center')};
  gap: 0.75rem;
  position: relative;

  &:hover {
    border-color: ${(props) => (props.selected ? '#0c8de3' : '#94a3b8')};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(12, 141, 227, 0.08);
  }

  .icon-wrapper {
    font-size: 1.75rem;
    color: ${(props) => (props.selected ? '#0c8de3' : '#64748b')};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .card-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: ${(props) => (props.selected ? '#0C234C' : '#334155')};
    margin: 0;
  }

  .card-description {
    font-size: 0.78rem;
    color: #64748b;
    margin: 0;
  }
`;

export const PlanResultWrapper = styled.div`
  text-align: center;
`;

export const PlanHighlightCard = styled.div`
  background: linear-gradient(145deg, #0C234C 0%, #0a3d62 100%);
  color: #ffffff;
  border-radius: 20px;
  padding: 2.25rem 2rem;
  margin-bottom: 1.5rem;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(12, 35, 76, 0.25);

  &::before {
    content: '';
    position: absolute;
    top: -50px;
    right: -50px;
    width: 140px;
    height: 140px;
    background: radial-gradient(circle, rgba(103, 210, 220, 0.35) 0%, rgba(103, 210, 220, 0) 70%);
    border-radius: 50%;
  }

  .trial-badge {
    display: inline-block;
    background: linear-gradient(90deg, #67D2DC 0%, #0c8de3 100%);
    color: #0C234C;
    font-size: 0.8rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 0.4rem 1.25rem;
    border-radius: 999px;
    margin-bottom: 1rem;
  }

  .plan-name {
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0.25rem;
    color: #ffffff;
  }

  .plan-tagline {
    font-size: 0.85rem;
    color: #cbd5e1;
    margin-bottom: 1.5rem;
  }

  .feature-list {
    text-align: left;
    list-style: none;
    padding: 0;
    margin: 0 0 1rem 0;

    li {
      display: flex;
      align-items: center;
      gap: 0.6rem;
      font-size: 0.88rem;
      color: #f1f5f9;
      margin-bottom: 0.6rem;

      .check-icon {
        color: #67D2DC;
        font-weight: bold;
      }
    }
  }
`;

export const NavigationButtonsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.75rem;
  gap: 1rem;
`;

export const ActionButton = styled.button`
  height: 48px;
  padding: 0 1.75rem;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  ${(props) =>
    props.primary
      ? css`
          background: linear-gradient(90deg, #0c8de3 0%, #0060b0 100%);
          color: #ffffff;
          border: none;
          flex: 1;

          &:hover:not(:disabled) {
            background: linear-gradient(90deg, #0a7cc8 0%, #005096 100%);
            box-shadow: 0 4px 14px rgba(12, 141, 227, 0.35);
          }

          &:disabled {
            background: #cbd5e1;
            cursor: not-allowed;
          }
        `
      : css`
          background: #ffffff;
          color: #64748b;
          border: 1.5px solid #cbd5e1;

          &:hover {
            background: #f8fafc;
            color: #1e293b;
            border-color: #94a3b8;
          }
        `}
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.8rem;
  color: #475569;
  cursor: pointer;
  margin-top: 1rem;
  line-height: 1.4;

  input[type='checkbox'] {
    margin-top: 0.2rem;
    cursor: pointer;
  }

  a {
    color: #0c8de3;
    text-decoration: underline;
    &:hover {
      color: #0060b0;
    }
  }
`;
